module.exports = __webpack_public_path__ + "static/media/icon_robot_body_japanese.e17b5a3e.svg";